import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
        name: 'sortByOrder'
      })
export class SortByOrderPipe implements PipeTransform {

  transform<T>(value: Array<T>): Array<T> {
    return value.sort((n1, n2) => n1['order'] - n2['order']);
  }
}
